import {Design} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {Shortcuts} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/KeyboardController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SpaceDesignList} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/spaceDesignList/SpaceDesignList';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./TopMenu.less');
const cx = classnames.bind(styles);

export abstract class DesignMenuItems
{
    public static build():IContextMenuItem[]
    {
        const {keyboard, topMenu} = controllers.ui;

        const versionHistory:IContextMenuItem[] = ConfigUtil.isVersionHistoryMenuEnabled()
            ? [
                {
                    isSeparator: true
                },
                {
                    label: 'Version history',
                    dataSource: this.buildVersionHistoryMenuItems()
                }
            ] : [];

        return [
            {
                label: 'Publish as application',
                rightLabel: keyboard.getShortcutLabel(Shortcuts.DESIGNER_OPEN_PUBLISH_DIALOG),
                icon: <WSPIcon className={cx('icon')} name={WSPIcons.visualDesigner.topBar.Publish} />,
                handler: topMenu.publishAsApplicationHandler
            },
            // {
            //     label: 'Share with people',
            //     icon: <WSPIcon className={cx('icon', {isDisabled: true})}
            //                    name={WSPIcons.visualDesigner.topBar.GroupAdd} />,
            //     isDisabled: true
            // },
            {
                isSeparator: true
            },
            {
                label: 'New',
                handler: topMenu.newDesignHandler
            },
            {
                label: 'Open',
                dataSource: <SpaceDesignList />
            },
            {
                label: 'Duplicate',
                rightLabel: keyboard.getShortcutLabel(Shortcuts.DESIGNER_DUPLICATE_DESIGN),
                handler: topMenu.duplicateDesignHandler
            },
            ...versionHistory,
            {
                isSeparator: true
            },
            {
                label: 'Rename',
                rightLabel: keyboard.getShortcutLabel(Shortcuts.DESIGNER_RENAME_DESIGN),
                handler: topMenu.renameDesignHandler
            },
            {
                label: 'Move',
                dataSource: this._buildMoveMenuItems()
            },
            {
                isSeparator: true
            },
            {
                label: 'Import from another design',
                handler: controllers.ui.topMenu.importFromDesignHandler
            }
        ];
    }

    public static buildVersionHistoryMenuItems():IContextMenuItem[]
    {
        const {keyboard} = controllers.ui;

        const isVersionsPanelVisible:boolean = controllers.ui.designVersions.isVersionsPanelVisible();

        return [
            {
                label: 'Name current version',
                rightLabel: keyboard.getShortcutLabel(Shortcuts.DESIGNER_NAME_CURRENT_VERSION),
                handler: controllers.ui.topMenu.nameCurrentVersionHandler
            },
            {
                label: `${isVersionsPanelVisible ? 'Hide' : 'Show'} version history`,
                rightLabel: keyboard.getShortcutLabel(Shortcuts.DESIGNER_TOGGLE_VERSIONS_VIEW),
                handler: controllers.ui.topMenu.showHideVersionHistoryHandler
            }
        ];
    }

    private static _buildMoveMenuItems():IContextMenuItem[]
    {
        const {designId} = controllers.ui.openDesign.getOpenDesign().designRef;
        const {projects} = rootState.data;
        const {currentProject} = rootState.ui.mainPage;
        const currentDesign:Design = rootState.ui.mainPage.currentDesigns.find(({id}) => id === designId);

        return projects
            .filter(project => project.id !== currentProject.id)
            .map(project => ({
                label: project.name,
                handler: () =>
                {
                    controllers.data.designs.moveDesign(currentProject, currentDesign, project);
                    controllers.navigation.toDesign(project.id, currentDesign.id);
                }
            }));
    }
}
